import React, { useState } from 'react';
import { HomepageFooter, HomepageHeader, PageModule, PageModuleType } from '../../../../../../../types/working-model';
import Icon, { COLORS, ICONS } from '../../../../../../general-ui/icon';
import { hasHeaderControls } from '../../../../session/editor/moduleControls/controls';
import HomepageHeaderAdvancedLayout from './advanced-settings-options/homepage-header-advanced-layout';
import MainEventBannerAdvancedLayout from './advanced-settings-options/main-event-banner';

interface IAdvancedLayoutSettingsProps {
	selectedModule: PageModuleType | HomepageHeader | HomepageFooter;
	onUpdate?: any;
	module?: PageModule;
}

const AdvancedLayoutSettings: React.FC<IAdvancedLayoutSettingsProps> = (props) => {
	const {
		selectedModule,
		onUpdate,
		module
	} = props;

	const [displayAdvancedSettings, setDisplayAdvancedSettings] = useState(false);

	function getLayoutAdvancedSettings() {
		switch (selectedModule) {
			case PageModuleType.main_event_banner:
				if (!module) return null;
				return <MainEventBannerAdvancedLayout module={module} />;
		}

		if (hasHeaderControls(selectedModule)) return (<HomepageHeaderAdvancedLayout module={selectedModule} onUpdate={onUpdate} />);

	}

	return (
		<div className="advanced-settings">
			<div className="text-container">
				<h5 className="title">Advanced settings</h5>
				<button
					className={`no-style ${!displayAdvancedSettings ? 'arrow-down' : ''}`}
					onClick={() => setDisplayAdvancedSettings(!displayAdvancedSettings)}
				>
					<Icon
						name={ICONS.KEYBOARD_ARROW_UP}
						color={COLORS.WHITE}
						size={16}
					/>
				</button>
			</div>
			{displayAdvancedSettings && getLayoutAdvancedSettings()}
		</div>
	);
};

export default AdvancedLayoutSettings;
